import React, { useState, Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import useSWR from 'swr';
import api from './config/Api';
import Swal from 'sweetalert2';
import { Auth } from './utils/Auth';
import toast, { Toaster } from 'react-hot-toast';

import ProtectedRoute from './components/ProtectedRoute';
import LoadingPage from './pages/Loading';

import AOS from "aos";
import "aos/dist/aos.css";
// Lazy load pages
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const Home = lazy(() => import('./pages/Home'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const UserManagement = lazy(() => import('./pages/UserManagement'));
const RoleManagement = lazy(() => import('./pages/RoleManagement'));
const Pages = lazy(() => import('./pages/Pages'));
const SubDistricts = lazy(() => import('./pages/SubDistricts'));
const Levels = lazy(() => import('./pages/Levels'));
const CategoryProfile = lazy(() => import('./pages/CategoryProfile'));
const CategoryInformation = lazy(() => import('./pages/CategoryInformation'));
const PublicInformation = lazy(() => import('./pages/PublicInformation'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Profile = lazy(() => import('./pages/Profile'));
const TypeInformation = lazy(() => import('./pages/TypeInformation'));
const Report = lazy(() => import('./pages/Report'));
const OrderReport = lazy(() => import('./pages/OrderReport'));
const SearchDokumen = lazy(() => import('./pages/SearchDokumen'));
const DocumentDetail = lazy(() => import('./pages/DocumentDetail'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const Slide = lazy(() => import('./pages/Slide'));
const Villages = lazy(() => import('./pages/Villages'));
const Occupations = lazy(() => import('./pages/Occupations'));
const Complaint = lazy(() => import('./pages/Complaint'));
const Kitchens = lazy(() => import('./pages/Kitchens'));
const EducationMajors = lazy(() => import('./pages/EducationMajors'));
const Lapor = lazy(() => import('./pages/Lapor'));
const KitchenMaps = lazy(() => import('./pages/KitchenMaps'));
const Statistik = lazy(() => import('./pages/Statistik'));
const Individu = lazy(() => import('./pages/Individu'));
const Family = lazy(() => import('./pages/Family'));
const ResidentsManagement = lazy(() => import('./pages/ResidentsManagement'));
const Track = lazy(() => import('./pages/Track'));
const ReportDetail = lazy(() => import('./pages/ReportDetail'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const SchoolsManagement = lazy(() => import('./pages/SchoolsManagement'));
const Institution = lazy(() => import('./pages/Institution'));
const MyProfile = lazy(() => import('./pages/MyProfile'));
const MBGReportInfo = lazy(() => import('./pages/LaporInfo'));
const Logs = lazy(() => import('./pages/Logs'));
const ReportDashboard = lazy(() => import('./components/Dashboard/ReportDashboard'));
const Menu = lazy(() => import('./pages/Menu'));
const MenuReview = lazy(() => import('./pages/MenuReview'));

export const fetcher = async (url, body) => {
  const response = await api.post(url, body);
  return response.data;
};

const viewComponents = {
  Dashboard,
  UserManagement,
  RoleManagement,
  Pages,
  SubDistricts,
  Levels,
  CategoryProfile,
  CategoryInformation,
  PublicInformation,
  TypeInformation,
  Report,
  OrderReport,
  Villages,
  Occupations,
  Complaint,
  Kitchens,
  EducationMajors,
  Lapor,
  ResidentsManagement,
  Track,
  ReportDetail,
  ForgotPassword,
  ResetPassword,
  KitchenMaps,
  SchoolsManagement,
  Institution,
  MyProfile,
  MBGReportInfo,
  Logs,
  Slide,
  ReportDashboard,
  Menu,
  MenuReview
};

const renderRoutesFromMenu = (pages) =>
  pages.flatMap(page => {
    const routes = [];

    if (page.name && viewComponents[page.view_name]) {
      const Component = React.createElement(viewComponents[page.view_name]);

      routes.push(
        <Route
          key={page.url}
          path={page.url}
          element={
            page.protectroute ? (
              <ProtectedRoute>{Component}</ProtectedRoute>
            ) : (
              Component
            )
          }
        />
      );
    }

    if (page.children?.length) {
      routes.push(...renderRoutesFromMenu(page.children));
    }

    return routes;
  });


export default function App() {
  const [user] = useState(() => Auth.getUser());
  const staticMenus = [
    {
      "icon": "FaHome",
      "name": "Home",
      "route_name": "home",
      "url": "/",
      "view_name": "Home",
      "protectroute": false
    },
    {
      "icon": "FaHome",
      "name": "Login",
      "route_name": "login",
      "url": "/login",
      "view_name": "Login",
      "protectroute": false
    },
    {
      "icon": "FaHome",
      "name": "Track",
      "route_name": "track",
      "url": "/track",
      "view_name": "Track",
      "protectroute": true
    },
    {
      "icon": "FaHome",
      "name": "Lapor",
      "route_name": "lapor",
      "url": "/lapor",
      "view_name": "Lapor",
      "protectroute": true
    },
    {
      "icon": "FaHome",
      "name": "Track",
      "route_name": "track",
      "url": "/track",
      "view_name": "Track",
      "protectroute": true
    },
    {
      "icon": "FaHome",
      "name": "Dashboard",
      "route_name": "dashboard",
      "url": "/dashboard",
      "view_name": "Dashboard",
      "protectroute": true
    },
    {
      "icon": "FaUsers",
      "name": "User Management",
      "route_name": "users",
      "url": "/users",
      "view_name": "UserManagement",
      "protectroute": true
    },
    {
      "icon": "FaHome",
      "name": "Pengaduan",
      "route_name": "complaint",
      "url": "/complaint",
      "view_name": "Complaint",
      "protectroute": true
    },
    {
      "icon": "FaHome",
      "name": "Kitchens",
      "route_name": "kitchens",
      "url": "/kitchens",
      "view_name": "Kitchens",
      "protectroute": true
    },
    {
      "icon": "FaSchools",
      "name": "Penerima MBG Management",
      "route_name": "penerima",
      "url": "/recipient-mbg",
      "view_name": "SchoolsManagement",
      "protectroute": true
    },
    {
      "icon": "FaSchools",
      "name": "Penerima MBG Management",
      "route_name": "penerima",
      "url": "/user",
      "view_name": "SchoolsManagement",
      "protectroute": true
    },
    {
      "icon": "FaUtensils",
      "name": "Menu Makanan",
      "route_name": "menu",
      "url": "/menu",
      "view_name": "Menu",
      "protectroute": true
    },
    {
      "icon": "FaChartLine",
      "name": "Menu Review",
      "route_name": "menu-review",
      "url": "/menu-review",
      "view_name": "MenuReview",
      "protectroute": true
    },
  ]

  // filter langsung di array pakai if di callback
  const accessibleMenu = staticMenus.filter(item => {
    if (!user) return ["track", "lapor"].includes(item.route_name);
    if (user?.role === "admin") return true; // semua menu
    if (user?.role === "user") return ["track", "lapor"].includes(item.route_name);
    if (user?.role === "dapur") return ["dashboard", "complaint", "penerima", "menu"].includes(item.route_name);
    if (user?.role === "school") return ["dashboard", "menu-review"].includes(item.route_name);
    return false;
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,   // durasi animasi (ms)
      once: true,       // animasi hanya dijalankan sekali
      easing: "ease-in-out", // jenis easing
    });
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/user-profile" element={<Profile />} />
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/saluran-pengaduan" element={<MBGReportInfo />} /> */}
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/data-sppg" element={<Institution />} />
          <Route path="/kitchen-maps" element={<KitchenMaps />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/track/:token" element={<ReportDetail />} />
          <Route path="/dashboard-reports-detail" element={<ReportDashboard />} />

          {renderRoutesFromMenu(accessibleMenu)}

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}